<template>
  <div class="container">
    <span class="title">购买会员</span>
    <span class="sub-title">会员可无限保存，不消耗次数</span>

    <span class="select-product">请选择您的套餐：</span>

    <div class="vip-container">
      <div v-for="(item, index) in list" v-bind:key="index" @click="vipItemClick(index)" v-bind:class="[
        itemIndex == index ? 'vip-item vip-item-active' : 'vip-item',
      ]">
        <div class="vip-price" v-bind:style="{ color: itemIndex == index ? '#f82741' : '#000000' }">
          {{ item.discount }}
        </div>
        <div class="vip-time" v-bind:style="{ color: itemIndex == index ? '#f82741' : '#666666' }">
          {{ item.dayStr }}
        </div>
        <div class="vip-desc">{{ item.memberDesc }}</div>
        <img v-if="item.showIcon" class="vip-discount-icon" src="../assets/discount.png" />
      </div>
    </div>

    <span class="select-pay-type">请选择支付方式：</span>
    <div class="vip-container">
      <div @click="payTypeClick(0)" v-bind:class="[
        payType == 0 ? 'pay-type-item pay-type-item-active' : 'pay-type-item',
      ]">
        <img class="pay-type-icon" src="../assets/wpay.png" />
        <div class="pay-type-text">微信支付</div>
      </div>

      <div @click="payTypeClick(1)" v-bind:class="[
        payType == 1 ? 'pay-type-item pay-type-item-active' : 'pay-type-item',
      ]">
        <img class="pay-type-icon" src="../assets/wpay_scan.png" />
        <div class="pay-type-text">微信扫码</div>
      </div>

      <div @click="payTypeClick(2)" v-bind:class="[
        payType == 2 ? 'pay-type-item pay-type-item-active' : 'pay-type-item',
      ]">
        <img class="pay-type-icon" src="../assets/zfb.png" />
        <div class="pay-type-text">支付宝扫码</div>
      </div>
    </div>

    <div @click="payClick()" class="pay-button">
      <div class="price-sign">¥</div>
      <div class="price-text">{{ list[itemIndex].discount }}</div>
      <div class="pay-text">{{ payText }}</div>
    </div>

    <div v-if="list.length > 0 && list[itemIndex].expireTime" class="expire-time">
      购买后会员有效期至：{{ list[itemIndex].expireTime }}
    </div>

    <div class="tip-title">温馨提示</div>

    <div class="tip-content">1、不会自动续费，请放心购买</div>
    <div class="tip-content">2、支付成功后，返回小程序即可使用</div>
    <div class="tip-content">3、购买成功后，不支持退款</div>
    <div class="tip-content">4、有任何问题，都可以与客服联系</div>

    <div class="code-container" v-if="showPayQrCode && qrCode">
      <div class="code-content">
        <div>请扫码付款（可以截图后扫一扫）</div>
        <!-- <img class="qr-code-img" :src="qrCode" /> -->

        <vue-qr v-if="qrText" :text="qrText" :size="200" :margin="10" :logoScale="0.15" :logoSrc="logoSrc"></vue-qr>

        <img v-else class="qr-code-img" :src="qrCode" />


        <div>付款成功后会员会自动开通</div>
      </div>

      <img @click="hideCode()" class="close" src="../assets/close.png" />
    </div>
  </div>
</template>

<script>

import VueQr from 'vue-qr'
import router from '../router';
const axios = require("axios");

export default {

  components: {
    VueQr
  },

  data: function () {
    return {
      list: [{}, {}, {}, {}],
      itemIndex: 1,
      wechat: "",
      qrCode: "",

      //0: 微信内支付； 1: 微信扫码支付；  2:支付宝扫码支付
      payType: 0,

      showPayQrCode: false,

      payText: "微信支付",
      loading: false,

      qrText: "",
      logoSrc: ""

    };
  },

  mounted: function () {
	  
	 //  let domain = window.location.hostname
	 //  console.log(domain)
	 //  if (domain != null && domain.indexOf("yuantujun.com") > 0) {
		// this.$router.replace('/');
		// return
	 //  }
	  
    let openId = this.$route.query.openid;
    this.openId = openId;
	if (!openId) {
		this.$router.replace('/');
	} else {
		axios
		  .get("/api/member/getMemberConfig?openId=" + openId + "&version=v2")
		  .then((response) => {
		    console.log(response);
		    let data = response.data.data;
		    this.wechat = data.wechat;
			if (data.wechat) {
				this.list = data.memberList;
			} else {
				this.$router.replace('/');
			}
			
		  })
		  .catch((error) => {
		    console.log(error);
		  });
	}


    console.log(openId);
  },

  methods: {
    vipItemClick: function (index) {
      this.itemIndex = index;
    },

    payTypeClick: function (type) {
      this.payType = type;
      if (this.payType == 0) {
        this.payText = "微信支付";
      } else if (this.payType == 1) {
        this.payText = "微信扫码";
      } else if (this.payType == 2) {
        this.payText = "支付宝扫码";
      }
    },

    hideCode: function () {
      this.showPayQrCode = false;
    },

    payClick: function () {
      if (this.loading) {
        return;
      }
      console.log("payClick");
      let openId = this.openId;

      console.log(openId);
      this.loading = true;
      this.payText = "请求中...";

      let item = this.list[this.itemIndex];
      var param = new URLSearchParams();
      param.append("openId", openId);
      param.append("configId", item.id);
      param.append("payType", this.payType);
      axios
        .post("/api/member/pay", param)
        .then((response) => {
          this.loading = false;
          if (this.payType == 0) {
            this.payText = "微信支付";
          } else if (this.payType == 1) {
            this.payText = "微信扫码";
          } else if (this.payType == 2) {
            this.payText = "支付宝扫码";
          }
          console.log(response);
          if (response.data.code != 0) {
            let errorMsg = "服务端异常";
            if (response.data.msg) {
              errorMsg = response.data.msg;
            }
            this.openWrongUrlAlert(errorMsg);
            return;
          }
          var data = response.data.data;

          if (data.payUrl) {
            window.location.href = data.payUrl;
          } else if (data.payQrCode || data.qrText) {
            this.qrCode = data.payQrCode
            this.qrText = data.qrText
            if (data.pay_type == "alipay") {
              this.logoSrc = require("../assets/zfb.png")
            } else {
              this.logoSrc = require("../assets/wpay.png")
            }
            this.showPayQrCode = true
          } else {
            this.openWrongUrlAlert("支付失败，请与客服联系!!");
          }
        })
        .catch((error) => {
          console.log(error);
          this.openWrongUrlAlert("请求失败，请与客服联系!!");
        });
    },

    openWrongUrlAlert: function (err) {
      alert(err || "操作失败");
    },
  },
};
</script>

<style>
body {
  background-color: #f4f5f6;
}

.container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.title {
  font-size: 28px;
  color: #000000;
  margin-top: 48px;
}

.sub-title {
  font-size: 14px;
  color: #999999;
}

.select-product {
  width: 100%;
  font-size: 14px;
  margin-top: 48px;
  padding-left: 6px;
  color: #666666;
}

.select-pay-type {
  width: 100%;
  font-size: 14px;
  margin-top: 18px;
  padding-left: 6px;
  color: #666666;
}

.vip-container {
  display: flex;
  flex-direction: row;
  width: 100%;
  margin-top: 12px;
  position: relative;
}

.vip-item {
  width: 25%;
  height: 100px;
  margin-left: 3px;
  margin-right: 3px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: white;
  border-radius: 4px;
  border-style: solid;
  border-color: #f4f5f6;
  border-width: 1px;
  position: relative;
}

.vip-item-active {
  border-color: #f82741;
}

.pay-type-item {
  height: 32px;
  margin-left: 4px;
  margin-right: 4px;
  background-color: white;
  border-radius: 4px;
  border-style: solid;
  border-color: white;
  border-width: 1px;
  padding-left: 6px;
  padding-right: 6px;
  align-items: center;
  display: flex;
}

.pay-type-item-active {
  border-color: #f82741;
}

.pay-type-text {
  font-size: 14px;
  color: #666666;
  margin-left: 3px;
}

.pay-type-icon {
  width: 18px;
  height: 18px;
}

.vip-price {
  font-size: 22px;
}

.vip-price::after {
  content: "元";
  font-size: 14px;
}

.vip-desc {
  font-size: 10px;
  color: #f82741;
  margin-top: 2px;
}

.vip-time {
  font-size: 16px;
  margin-top: 2px;
}

.vip-discount-icon {
  width: 25px;
  height: 25px;
  position: absolute;
  top: 0;
  left: 0;
}

.pay-price-title {
  font-size: 18px;
  color: #999999;
}

.pay-price {
  font-size: 48px;
  color: black;
}

.pay-button {
  display: flex;
  width: 260px;
  height: 48px;
  background-color: #f82741;
  border-radius: 30px;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 20px;
  margin-top: 36px;
}

.price-sign {
  font-size: 15px;
  margin-top: 6px;
}

.price-text {
  font-size: 25px;
  margin-left: 3px;
}

.pay-text {
  font-size: 20px;
  margin-left: 12px;
  margin-bottom: 2px;
}

.expire-time {
  font-size: 14px;
  color: #999999;
}

.tip-title {
  color: #666666;
  width: 90%;
  font-size: 16px;
  font-weight: bold;
  margin-top: 36px;
}

.tip-content {
  width: 90%;
  font-size: 14px;
  color: #999999;
  margin-top: 2px;
}

.code-container {
  position: fixed;
  top: 0px;
  left: 0px;
  background: #00000071;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.code-content {
  display: flex;
  flex-direction: column;
  padding: 24px;
  background: white;
  justify-content: center;
  align-items: center;
  color: #666666;
}

.close {
  width: 32px;
  height: 32px;
  margin-top: 24px;
}

.qr-code-img {
  width: 250px;
  height: 250px;
}
</style>
